var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-bill-delay',{staticClass:"pt-bill-delay__withData"})
}
var staticRenderFns = []

export { render, staticRenderFns }